import React, { useEffect, useMemo } from 'react';
import { ComponentProps } from 'types';
import { ATTA_REPORT } from 'lib/constants/atta';
import { report } from 'lib/utils/dataReport';
import { showReceiveLimitDialog } from 'lib/components/ReceiveDialog';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import { ORDER_STATE } from 'lib/constants/order';
import { showModal } from 'lib/components/Modal';
import channelService from 'lib/services/channelService';
import './index.scss';

export default function ({ commonStyle }: ComponentProps<Record<string, never>>) {
  const userOrderInfo = useUserOrderStore(state => state.userOrderInfo);
  const visible = useMemo(
    () => userOrderInfo?.orderState === ORDER_STATE.ORDER_SUCCESS && !!userOrderInfo?.isOverYear,
    [userOrderInfo],
  );

  useEffect(() => {
    if (visible) {
      report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.FIXED_ENTRY_VIEW);
    }
  }, [visible]);

  const openReceiveTips = () => {
    report(ATTA_REPORT.CMCC_RECEIVE_LIMIT.FIXED_ENTRY_CLICK);
    if (!channelService.gameCode) {
      return;
    }
    showModal(showReceiveLimitDialog(true, channelService.gameCode));
  };

  return (process.env.IS_EDITOR || visible) ? (
    <div className='receive-apply-entry' style={commonStyle}>
      <div className="receive-apply" onClick={openReceiveTips}>
        <div className="receive-apply__text">增加领奖次数</div>
        <div className="receive-apply__icon"></div>
        <div className="arrow-icon"></div>
      </div>
    </div>
  ) : null;
};
